import { useQuery } from 'react-query';
import { Resources } from '@/src/shared/constants/resources';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { firebaseStorage } from '@/src/auth/FirebaseAuth';

export function useGetUsersByIds(userUids: string[]) {
  const usersByIdsQuery = useQuery(
    [Resources.Profiles, ...(userUids || [])],
    async () => {
      const usersRequest = await getDocs(
        query(
          collection(firebaseStorage, Resources.Profiles),
          where('uid', 'in', userUids)
        )
      );

      return {
        data: usersRequest.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })),
        total: usersRequest.size,
      };
    },
    {
      enabled: !!userUids?.length,
    }
  );

  return usersByIdsQuery;
}
